import { ArrowUpRight } from "lucide-react";
import { scrollToId } from "@/lib/site";

const ITEMS = [
  ["limpeza-comercial", "01", "Limpeza comercial", "Escritórios, clínicas e empresas · planos recorrentes", true],
  ["faxina-residencial", "02", "Faxina residencial", "Casas e apartamentos · limpeza pesada", false],
  ["limpeza-pos-obra", "03", "Limpeza pós-obra", "Imóveis residenciais e comerciais", false],
];

export const ServiceStrip = () => (
  <nav aria-label="Serviços" className="max-w-[1400px] mx-auto px-5 md:px-10 pb-14 md:pb-20" data-testid="service-strip">
    <div className="grid md:grid-cols-3 border-t border-[#121518]/10">
      {ITEMS.map(([id, n, t, d, main]) => (
        <button key={id} data-testid={`strip-${id}`} onClick={() => scrollToId(id)}
          className="group text-left py-6 md:px-6 md:first:pl-0 border-b md:border-b-0 md:border-r last:border-r-0 border-[#121518]/10 flex items-start gap-4">
          <span className="font-mono-d text-xs text-[#C59B27] pt-1.5">{n}</span>
          <span className="flex-1">
            <span className="flex items-center gap-2 font-serif-d text-2xl md:text-3xl">
              {t}
              {main && <span className="font-mono-d text-[10px] tracking-[0.2em] bg-[#0F4C3A] text-[#FAF8F5] px-2 py-1">DESTAQUE</span>}
            </span>
            <span className="block text-sm text-[#525860] mt-1">{d}</span>
          </span>
          <ArrowUpRight size={20} className="text-[#0F4C3A] transition-transform duration-300 group-hover:rotate-45" />
        </button>
      ))}
    </div>
  </nav>
);
